import { useTheme } from '@shopify/restyle';
import { Button } from 'app/design/primitives/button';
import { useScopedTranslation } from 'app/hooks/i18n';
import { Accessory } from 'app/design/primitives/page/accessory';
import { isMobileNative } from 'app/utils/web-helpers';
import { OnMobileNativeOnly } from 'app/components/native-only';
import type { Theme } from 'app/shopify';

export function InvitePageActions({ onCopy, onShare }: { onCopy: () => void; onShare: () => void }) {
  const { t } = useScopedTranslation();
  const theme = useTheme<Theme>();
  return (
    <Accessory style={{ marginHorizontal: theme.spacing['spacing.general.x4'] }}>
      <Button marginTop="spacing.general.x2" onPress={onCopy} variant={isMobileNative ? 'secondary' : 'primary'}>
        {t('secondaryButtonText')}
      </Button>
      <OnMobileNativeOnly>
        <Button marginTop="spacing.general.x2" onPress={onShare} variant="primary">
          {t('primaryButtonText')}
        </Button>
      </OnMobileNativeOnly>
    </Accessory>
  );
}
